import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
  useStylesUp, useStylesHed, useStylesAuto,useStylesAutoPurch,useStylesTF, useStylesTD, useStylesBA, useStylesLbl
  , useStylesUiElemment,
  useStylesSpDial,useStylesAutoBlack,
} from '../../../../../St/Reports/UseStyle';
import { sto } from '../../../../../Context/InshData';
import { useTranslation } from 'react-i18next';


export default function RetrictionsSearchForm(props){

  const {
    type,
    rptParams,
   onChangeData,
   onChangeAutoData,
 AutoOptions,
 branches
  }=props;
  const { t } = useTranslation(["forms"]);

  const clasup = useStylesUp();
  const calsPurch = useStylesAutoPurch();
  const claslbl = useStylesLbl();
  const clasAo = useStylesAutoBlack();
  const clasTF = useStylesTF();
    return (
          <React.Fragment>
              <Grid container style={{padding:5 }} spacing={1}>
              <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);
                            // console.log(newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={ sto.User_typei == 1?branches: AutoOptions?.Branches}
                        disabled={ sto.User_typei == 1?false:true}
                        style={{color:'black',fontWeight:"bold",fontSize:"1rem"}}
                        InputProps={{ className:claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                        renderInput={(params) => (
                            <TextField
                            id="user"
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className:claslbl.clrBlackLblS}}
                            />
                        )}
                    />

                </Grid>
              <Grid item lg={2} md={2} sm={4} xs={6} style={{fontWeight:"bold" ,paddingBottom:"0.5rem"}}>
                  <TextField fullWidth variant="outlined" size="small" id="dateT" 
                  label={t("rest_no")}
                  type="number" 
                  className={clasTF.rootCust} 
                  InputProps={{ className:claslbl.clrBlackTxt }}
                  InputLabelProps={{className:claslbl.clrBlackLblS}}
                  name="doc_no2" value={rptParams.doc_no2} 
                  onChange={onChangeData("doc_no2")}/>
                </Grid>

                <Grid item lg={2} md={2}  sm={4} xs={6} style={{fontWeight:"bold" ,paddingBottom:"0.5rem"}}>
                    <TextField  fullWidth variant="outlined" size="small" id="datef" 
                    label={t("date-from")}
                    className={clasTF.rootCust} 
                    InputProps={{ className:claslbl.clrBlackTxt }}
                    InputLabelProps={{className:claslbl.clrBlackLblS}}
                    type="date" format="YYYY-MM-DD"
                    name="dateFrom" value={rptParams.dateFrom} 
                    onChange={onChangeData("dateFrom")}/>
                </Grid>
                <Grid item lg={2} md={2}  sm={4} xs={6} style={{fontWeight:"bold" ,paddingBottom:"0.5rem"}}>
                    <TextField  fullWidth variant="outlined" size="small" id="datef" 
                    label={t("date-to")}
                    className={clasTF.rootCust} 
                    InputProps={{ className:claslbl.clrBlackTxt }}
                    InputLabelProps={{className:claslbl.clrBlackLblS}}
                    type="date" format="YYYY-MM-DD"
                    name="dateTo" value={rptParams.dateTo} 
                    onChange={onChangeData("dateTo")}/>
                </Grid>

                <Grid item lg={2} md={2} sm={4} xs={6} style={{fontWeight:"bold" ,paddingBottom:"0.5rem"}}>
                  <TextField fullWidth variant="outlined" size="small" id="dateT" 
                  label={t("debit-amount")}
                  type="number" 
                  className={clasTF.rootCust} 
                  InputProps={{ className:claslbl.clrBlackTxt }}
                  InputLabelProps={{className:claslbl.clrBlackLblS}}
                  name="deptval" value={rptParams.deptval} 
                  onChange={onChangeData("deptval")}/>
                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={6} style={{fontWeight:"bold" ,paddingBottom:"0.5rem"}}>
                  <TextField fullWidth variant="outlined" size="small" id="dateT" 
                  label={t("credit-amount")}
                  type="number" 
                  className={clasTF.rootCust} 
                  InputProps={{ className:claslbl.clrBlackTxt }}
                  InputLabelProps={{className:claslbl.clrBlackLblS}}
                  name="creditval" value={rptParams.creditval} 
                  onChange={onChangeData("creditval")}/>
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        InputProps={{ className:claslbl.clrBlackTxt }}
                        value={rptParams.user}
                        onChange={(event, newValue) => {
                            onChangeAutoData("user", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions.Users}
                        style={{color:'black',fontWeight:"bold",fontSize:"1rem"}}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                        renderInput={(params) => (
                            <TextField
                            id="user"
                                {...params}
                                label={t("user")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className:claslbl.clrBlackLblS}}
                            />
                        )}
                    />

                </Grid>                           
               
               
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={rptParams.center}
                        onChange={(event, newValue) => {
                            onChangeAutoData("center", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions.costcenters}
                        style={{color:'black',fontWeight:"bold",fontSize:"1rem"}}
                        InputProps={{ className:claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                          }
                        renderInput={(params) => (
                            <TextField
                            id="center"
                                {...params}
                                label={t("center")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className:claslbl.clrBlackLblS}}
                            />
                        )}
                    />

                </Grid> 

                <Grid item lg={4} md={4} sm={6} xs={12} style={{fontWeight:"bold" ,paddingBottom:"0.5rem"}}>
                  <TextField fullWidth variant="outlined" size="small" id="dateT" 
                  label={t("note")}
                  type="text" 
                  className={clasTF.rootCust} 
                  InputProps={{ className:claslbl.clrBlackTxt }}
                  InputLabelProps={{className:claslbl.clrBlackLblS}}
                  name="notes" value={rptParams.notes} 
                  onChange={onChangeData("notes")}/>
                </Grid>
              


 
            </Grid>  

          </React.Fragment>
          
    );
 
}